import { themeGet } from '@pocketlaw/tetris';
import styled from 'styled-components';
export const Container = styled.div `
  padding: ${themeGet('spacing.6xl')} 0;
`;
